import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { ILoginTypeOtpData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the type mutation keys in react query cache.
 */
const LOGIN_OTP_MUT = 'login-otp-mutation-key';

interface IUseLoginTypeOptions {
  onSuccessCallback: (loginTypeOtpData: ILoginTypeOtpData) => void;
  onErrorCallback: (error: IApiError) => void;
}

/**
 * This performs a login type check request.
 */
export const useLoginTypeOtpMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseLoginTypeOptions) => {
  const { isPending, error, mutate } = useMutation({
    mutationKey: [LOGIN_OTP_MUT],
    networkMode: 'always',
    mutationFn: USER_ACCOUNTS_API.loginUserOTP,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    error,
    isPending,
    submitLoginOtpType: mutate,
  };
};
